import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const ShopContext = createContext(null);

const ShopContextProvider = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [token, setToken] = useState(localStorage.getItem("token"));

  // Fetch cart items from the backend and retrieve token if necessary
  const fetchCartItems = async () => {
    try {
      // Get the cart ID from localStorage
      const cartId = localStorage.getItem("cartId");

      const response = await axios.get(
        `https://kraafty-backend.onrender.com/api/get-cart-items/?cart_id=${cartId}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // If a new token is provided in the response, update both state and localStorage
      // if (response.data.token) {
      //     setToken(response.data.token);
      //     localStorage.setItem('token', response.data.token);
      // }

      setCartItems(response.data.data);
      console.log("Fetched cart items:", response.data.data);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const addToCart = async (
    product_pk,
    size,
    quantity,
    offer_price,
    mrp,
    is_direct_buy,
    currency = "USD" // Default to USD if not specified
  ) => {
    try {
      // Determine headers dynamically
      const headers = token ? { Authorization: `Token ${token}` } : {};
      const cartId = localStorage.getItem("cartId");
      
      // Convert prices to INR for Indian users
      // This stores the prices in INR for Indian users in the cart
      const exchangeRate = 84 * 0.4;
      function roundUpToNearest9(num) {
        num = Math.ceil(Number(num));
        if (num % 10 === 9) return num;
        return num + (9 - (num % 10));
      }
      let adjustedOfferPrice = offer_price;
      let adjustedMrp = mrp;
      if (currency === "INR") {
        adjustedOfferPrice = roundUpToNearest9(offer_price * exchangeRate);
        adjustedMrp = roundUpToNearest9(mrp * exchangeRate);
      }
      
      // Store the currency with the cart item to maintain consistency
      
      console.log(" add to cart :", {
        product_pk,
        size,
        quantity,
        offer_price: adjustedOfferPrice,
        mrp: adjustedMrp,
        is_direct_buy,
        cart_id: cartId,
        currency,
      });
      const response = await axios.post(
        "https://kraafty-backend.onrender.com/api/cart-items/",
        {
          product_pk,
          size,
          quantity,
          offer_price: adjustedOfferPrice,
          mrp: adjustedMrp,
          is_direct_buy,
          cart_id: cartId,
          currency,
        },
        { headers } // Send headers only when needed
      );

      // If a new token is provided in the response, update both state and localStorage
      if (response.data.token) {
        setToken(response.data.token);
        localStorage.setItem("token", response.data.token);
      }
      if (response.data.cart_id) {
        localStorage.setItem("cartId", response.data.cart_id);
      }

      fetchCartItems(); // Refresh cart items after adding
      console.log("Added to cart:", response.data.data);
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchCartItems();
    }
  }, [token]);

  const removeFromCart = async (
    product_pk,
    size,
    offer_price,
    mrp,
    is_direct_buy
  ) => {
    try {
      const config = is_direct_buy
        ? {}
        : {
            headers: {
              Authorization: `Token ${token}`,
            },
          };
      const cartId = localStorage.getItem("cartId");
      const response = await axios.post(
        "https://kraafty-backend.onrender.com/api/remove-cart-items/",
        {
          product_pk,
          size,
          offer_price,
          mrp,
          is_direct_buy,
          cart_id: cartId,
        },
        config
      );

      // If a new token is provided in the response, update both state and localStorage
      if (response.data.token) {
        setToken(response.data.token);
        localStorage.setItem("token", response.data.token);
      }
      if (response.data.cart_id) {
        localStorage.setItem("cartId", response.data.cart_id);
      }
      fetchCartItems(); // Refresh cart items after removal
      console.log("Item removed:", response.data);
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  };

  const getTotalCartAmount = () => {
    // No need to convert here as prices should already be in the correct currency
    // from the cart items API
    return cartItems.reduce(
      (total, item) => total + item.quantity * item.offer_price,
      0
    );
  };

  const getTotalCartItems = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  const clearCartItems = () => {
    setCartItems([]);
  };

  const contextValue = {
    getTotalCartItems,
    getTotalCartAmount,
    cartItems,
    addToCart,
    removeFromCart,
    clearCartItems,
    fetchCartItems,
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
